import React, { useMemo } from 'react';
import FavoriteProposalsTable from 'components/favorite-proposals';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import {
  FavoriteProposalsPageStore,
  FavoriteProposalsPageStoreContext,
} from 'store/pages/tools/favorite-proposals/pageStore';

const FavoriteProposalsPage = (): JSX.Element => {
  const pageStore = useMemo(() => new FavoriteProposalsPageStore(), []);

  return (
    <FavoriteProposalsPageStoreContext.Provider value={pageStore}>
      <NoSidebarPageLayout
        contentWidth="standard"
        pageHeader={{
          title: 'Favorite Proposals',
          subtitle: 'View and manage your saved favorite proposals',
        }}
      >
        <FavoriteProposalsTable />
      </NoSidebarPageLayout>
    </FavoriteProposalsPageStoreContext.Provider>
  );
};

export default FavoriteProposalsPage;
